import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';

import { htmlClassesToString } from '~/modules/helpers/string';

import Translate from '~/components/Translate/Translate';

const defaultWrapperClasses = [
    'loader-wrapper',
    'd-flex',
    'justify-content-center',
    'align-items-center',
    'h-100',
    'flex-column'
];

const defaultLoaderClasses = ['m-5'];

const Loader = props => {
    const computedWrapperClasses = htmlClassesToString(
        props.wrapperClasses,
        defaultWrapperClasses
    );
    const computedLoaderClasses = htmlClassesToString(
        props.loaderClasses,
        defaultLoaderClasses
    );

    return (
        <div
            className={computedWrapperClasses}
            {...(props.testId ? { 'data-sumo-test': props.testId } : {})}
        >
            <Spinner
                animation="border"
                variant="primary"
                className={computedLoaderClasses}
            />
            {props.message ? (
                <h5 className="text-center pt-4">
                    <Translate message={props.message} />
                </h5>
            ) : null}
        </div>
    );
};

Loader.propTypes = {
    wrapperClasses: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.func
    ]),
    loaderClasses: PropTypes.oneOfType([
        PropTypes.string, // string that will override all defaults
        PropTypes.array, // array which items will be merged with defaults
        PropTypes.func // function that will receive default as argument and must return a string
    ]),
    message: PropTypes.string, // replace 'text' prop todo chk use before commit
    testId: PropTypes.string
};

Loader.defaultProps = {
    wrapperClasses: null,
    loaderClasses: null,
    message: null
};

export default Loader;
